<script>
export default {
  components: {},
  mixins: [],
  props: {
    content: {
      type: [String, Number],
      required: true,
    },
    // Current cell size
    sizeX: {
      type: Number,
      required: true,
    },
    sizeY: {
      type: Number,
      required: true,
    },
  },
  validations: {},
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    };
  },
  computed: {
    fontSize() {
      const smallScreen = this.windowWidth < 1400;
      const smallCell = this.sizeY === 1;
      const stringBiggerThanFiveCharacters = this.content.toString().length > 5;
      if (smallScreen && smallCell && stringBiggerThanFiveCharacters)
        return 'text-3xl';
      if (smallCell && smallScreen) return 'text-4xl';
      return 'text-6xl';
    },
  },
  mounted() {
    // Adiciona o listener para o evento de redimensionamento da tela
    window.addEventListener('resize', this.updateWindowDimensions);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  },
  methods: {
    updateWindowDimensions() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<template>
  <div class="!text-slate-800" :class="fontSize">
    {{ content }}
  </div>
</template>
